var map = {
	"./exe.svg": "c3b6",
	"./filter.svg": "bcee",
	"./folder.svg": "bbde",
	"./image.svg": "d17f",
	"./music.svg": "65ea",
	"./pdf.svg": "4e08",
	"./ppt.svg": "be07",
	"./rar.svg": "34b3",
	"./txt.svg": "b6a0",
	"./video.svg": "2b54",
	"./word.svg": "721a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfd9";